import React from 'react'
import { Container, StyledInput } from './style'

//const Input = ({ ref, readOnly, onFocus,width, fill, id, type, name, placeholder, onChange, onBlur, value, mask, autoComplete, pattern, title, onKeyPress, disabled=false }) => {
const Input = React.forwardRef((props, ref) => {
  
  return (
      <Container width={props.width}>
        {
          ref &&
          <StyledInput ref={ ref } {...props} />
        }
        {
          !ref &&
          <StyledInput {...props} />
        }
        
      </Container>
  )
})

export default Input

